import { dataLayoutSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLayoutSolid = /*#__PURE__*/createIcon(dataLayoutSolid)
export default IconLayoutSolid
